import { getIn } from 'seamless-immutable';
import { stringify } from 'query-string';

export const getWarrantyUrl = (productId, currentSku, sellerStoreId, productQty = 1, extra = []) => {
  const queryString = {
    productId,
    condition: getIn(currentSku, ['offers', 'result', 0, 'condition']),
    productSku: getIn(currentSku, ['offers', 'result', 0, 'sku']),
    sellerId: getIn(currentSku, ['offers', 'result', 0, 'seller', 'id']),
    buyboxToken: getIn(currentSku, ['offers', 'meta', 'buyboxToken']),
    buyboxField: getIn(currentSku, ['offers', 'meta', 'buyboxField']),
    pricingId: getIn(currentSku, ['offers', 'result', 0, 'pricingId']),
    offerId: getIn(currentSku, ['offers', 'result', 0, 'id']),
    sellerStoreId,
    productQty,
  };

  if (extra.length > 0) {
    queryString.extra = JSON.stringify(extra);
  }

  return `/garantia/${productId}?${stringify(queryString)}`;
};

export const isExternalUrl = (url = '') => !!String(url).match(/(http:\/\/|https:\/\/|www)/gi);
